// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"DesktopBreadcrumb-module__breadcrumbs___1I-zw","tab":"DesktopBreadcrumb-module__tab___1Zxrl"};